import { jsx as _jsx } from "react/jsx-runtime";
import { Image } from '@chakra-ui/react';
import CBLogoImage from '@view/assets/images/cloudbeds-logo.png';
export const CbLogo = ({ height, width }) => {
    return (_jsx(Image, { alt: "cloudbeds-logo", height: height, src: CBLogoImage, width: width }));
};
